/* Каскад секций при скролле (приём bathmate): каждой полосе-обёртке ставим
   --pin-top = min(0, 100vh − высота секции) → CSS (base.css) пинит её sticky:
   длинная секция замирает низом у низа экрана, короткая — верхом у верха,
   а следующая наезжает поверх. Работает только на десктопе (медиа в CSS),
   здесь просто держим переменную актуальной при resize и изменении высоты
   (квиз растёт при показе результата, картинки догружаются). */
(function () {
  var wraps = [];

  function collect() {
    wraps = Array.prototype.slice
      .call(document.querySelectorAll('.content-for-layout > .shopify-section'))
      .filter(function (w) { return w.querySelector(':scope > .band') && !w.querySelector(':scope > .band--no-pin'); });
  }

  function setPins() {
    wraps.forEach(function (w) {
      w.style.setProperty('--pin-top', Math.min(0, window.innerHeight - w.offsetHeight) + 'px');
    });
  }

  function init() {
    collect();
    if (!wraps.length) { return; }
    setPins();

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(setPins);
      wraps.forEach(function (w) { ro.observe(w); });
    }
    window.addEventListener('resize', setPins);
    window.addEventListener('load', setPins);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
